import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { PharmacyNameWrapper } from '../../../../healtheraComponents';
import useLocationQuery from '../../../../hooks/useQuery';
import { getDashboardOrders } from '../../../../redux/dashboard';
import { addPharmacyNoteReset } from '../../../../redux/notes/addNoteReducer';
import { getPharmacyNotesReset } from '../../../../redux/notes/getNotesReducer';
import MaterialModal from '../../../MaterialModal/MaterialModal';
import { MODAL } from '../../constants';
import PharmacyFilter from '../PharmacyFilter';
import PharmacyModalContent from './PharmacyModalContent';

const PharmacyName = ({ pharmacyName, pharmacyId, hidePin = false }) => {
  const [isPharmacyModalOpen, setIsPharmacyModalOpen] = useState(false);
  const [isPharmacyFilterVisible, setIsPharmacyFilterVisible] = useState(false);
  const { note } = useSelector((state) => state.addNote);
  const query = useLocationQuery();

  const dispatch =  useDispatch();

  const handlePharmacyModalOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(getPharmacyNotesReset());
    dispatch(addPharmacyNoteReset());
    setIsPharmacyModalOpen(true);
  };

  const handlePharmacyModalClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPharmacyModalOpen(false);
    setIsPharmacyFilterVisible(false);
    if (note) dispatch(getDashboardOrders(query));
  };

  return (
    <PharmacyBlockWrapper
      onMouseEnter={() => setIsPharmacyFilterVisible(true)}
      onMouseLeave={() => setIsPharmacyFilterVisible(false)}
    >
      <PharmacyNameWrapper onClick={handlePharmacyModalOpen}>
        {pharmacyName}
      </PharmacyNameWrapper>
      {!hidePin && (
        <PharmacyFilter
          isPharmacyFilterVisible={isPharmacyFilterVisible}
          pharmacyId={pharmacyId}
        />
      )}
      <MaterialModal
        open={isPharmacyModalOpen}
        handleClose={handlePharmacyModalClose}
      >
        <PharmacyModalContent
          pharmacyId={pharmacyId}
          initialContent={MODAL.PHARMACY_INFO}
        />
      </MaterialModal>
    </PharmacyBlockWrapper>
  );
};

const PharmacyBlockWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export default PharmacyName;
